module.exports = __webpack_public_path__ + "static/media/matching-education-lateral-flexion-up.4bf0a022.png";